import { type Carer, Responsibility, UserRole } from '@lmc/ts-common'

/** Roles that can own an incident case or its follow-up actions. */
const INCIDENT_OWNER_ROLES: ReadonlyArray<UserRole> = [
  UserRole.careHomeAdmin,
  UserRole.groupAdmin,
  UserRole.groupManager,
  UserRole.management,
  UserRole.seniorCarer
]

/**
 * Whether a team member can own an incident case or a follow-up action. A
 * user has one role across all their homes, so this needs no home.
 */
export const canOwnIncidentWork = (carer: Pick<Carer, 'role'>): boolean =>
  INCIDENT_OWNER_ROLES.includes(carer.role)

/** Roles that may hold the Safeguarding responsibility, as the backend allows. */
const SAFEGUARDING_ROLES: ReadonlyArray<UserRole> = [
  UserRole.careHomeAdmin,
  UserRole.management
]

/**
 * Whether a team member can own a safeguarding incident's case or actions:
 * a safeguarding officer, as the backend defines one.
 */
export const canOwnSafeguardingWork = (
  carer: Pick<Carer, 'permissions' | 'role'>
): boolean =>
  SAFEGUARDING_ROLES.includes(carer.role) &&
  Boolean(carer.permissions?.includes(Responsibility.SafeguardingOfficer))
